import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledLabel, StyledInput } from "./RatingNumber.style";
import { Label } from "../../../Atoms";
const RatingNumber = ({ id, name, onChange, isChecked }) => {
    function handleKeyDown(e) {
        if (e.key === "Enter") {
            onChange(id);
        }
    }
    return (_jsxs(StyledLabel, { isChecked: isChecked, tabIndex: 0, onKeyDown: handleKeyDown, children: [_jsx(StyledInput, { id: id, name: name, type: "radio", checked: isChecked, value: id, onChange: (e) => {
                    onChange(e.target.value);
                } }), _jsx(Label, { size: "large", weight: "bold", children: id })] }));
};
export default RatingNumber;
//# sourceMappingURL=RatingNumber.js.map